export default __webpack_public_path__ + "static/media/misc-books4-480w.d5700f14.avif";